import { createFileRoute } from "@tanstack/react-router";
import { useCallback } from "react";
import z from "zod";

import { ScheduleOverviewGrid } from "@/features/schedule/components/schedule-overview-grid";
import { APP_ROUTES_TO } from "@/utils/routes";
import { searchValidator } from "@/utils/search-validator";

const SchedulesOverviewSearchSchema = z.object({
    view: z.enum(["week", "month"]).catch("week").default("week"),
    date: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/)
        .optional()
        .catch(undefined),
    team: z.string().optional().catch(undefined),
});

export const Route = createFileRoute("/management/schedules/")({
    component: SchedulesOverviewPage,
    validateSearch: searchValidator(SchedulesOverviewSearchSchema),
    staticData: {
        config: {
            title: "schedule_overview",
        },
    },
});

function SchedulesOverviewPage() {
    const navigate = Route.useNavigate();
    const { view, date, team } = Route.useSearch();
    const handleTeamChange = useCallback(
        (teamId: string) => navigate({ search: (prev) => ({ ...prev, team: teamId }), replace: true }),
        [navigate]
    );

    return (
        <div className="flex flex-col gap-5">
            <ScheduleOverviewGrid
                view={view}
                date={date}
                onPeriodChange={(period) => navigate({ search: (prev) => ({ ...prev, ...period }), replace: true })}
                teamId={team}
                onTeamChange={handleTeamChange}
                onSelectUser={(userId) =>
                    navigate({
                        to: APP_ROUTES_TO.MANAGEMENT_SCHEDULES_MANAGE,
                        search: { userId },
                    })
                }
            />
        </div>
    );
}
